import { SnackBarImp } from "../domain/snack-bar";
import { SnackBarModel } from "../domain/snack-bar.model";
import { inject, Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { SnackBarComponent } from '../snack-bar.component';

@Injectable({
  providedIn: "root",
})
export class MaterialSnackBar implements SnackBarImp {
  private matSnackBar: MatSnackBar = inject(MatSnackBar);
  private ref: MatSnackBarRef<SnackBarComponent> | undefined;
  private timeout: number | undefined;

  public open(config: SnackBarModel): Observable<void> {
    this.close();
    this.ref = this.matSnackBar.openFromComponent(SnackBarComponent, {
      panelClass: "app-snack-bar",
      data: config,
      verticalPosition: "top",
    });

    if (config.duration || !config.withCloseIcon) {
      this.timeout = setTimeout(() => {
        this.close();
      }, config.duration ?? 2000);
    }
    return this.ref.afterDismissed().pipe(
      map(() => {
        return;
      }),
    );
  }

  public close(): void {
    this.clearTimeout();
    this.ref?.dismiss();
  }

  private clearTimeout(): void {
    if (!this.timeout) {
      return;
    }
    clearTimeout(this.timeout);
    this.timeout = undefined;
  }
}
